import { render } from "./good-road-btn-svg.vue?vue&type=template&id=763dc99e&ts=true"
import script from "./good-road-btn-svg.vue?vue&type=script&lang=ts"
export * from "./good-road-btn-svg.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__